import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { useMemo } from 'react';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const pathFrontEnd = '/governanceroom/filetypehelps/';
    const pathsList = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'governanceroom/filetypes/getallhelps'
    };

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'sphere',
                type: 'select',
                label: 'Esfera',
                options: [
                    { label: 'Todas', value: '' },
                    { label: 'Municipal', value: 'Municipal' },
                    { label: 'Estadual', value: 'Estadual' },
                    { label: 'Nacional', value: 'Nacional' }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'periodicity',
                type: 'select',
                label: 'Periodicidade',
                options: [
                    { label: 'Todas', value: '' },
                    { label: 'Mensal', value: 'Mensal' },
                    { label: 'Anual', value: 'Anual' },
                    { label: 'Semestral', value: 'Semestral' },
                    { label: 'Quadrimestral', value: 'Quadrimestral' },
                    { label: 'Arquivo único', value: 'Arquivo único' }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 2
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    }), []);

    const list = useMemo(() => ({
        labelTitle: 'Lista de Configurações de Ajuda dos tipos de arquivos',
        labelTitleButtonAdd: '',
        canDelete: false,
        formFilters: filters,
        columns: [
            {
                name: 'file_category',
                label: 'Categoria',
                width: '20%'
            },
            {
                name: 'file_type',
                label: 'Tipo de Arquivo',
                width: '25%'
            },
            {
                name: 'sphere',
                label: 'Esfera',
                width: '12%'
            },
            {
                name: 'periodicity',
                label: 'Periodicidade',
                width: '15%'
            },
            {
                name: 'archive_help',
                label: 'Ajuda',
                width: '28%'
            }
        ],
        ...pathsList
    }), [filters]);

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={false}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
